import React from "react";
import Home from "./Home";
import { Row, Col, Icon, CardTitle, Card } from "react-materialize";
import { CheckAuth, API_COURSE_BASE_URL, QueryParam } from "../../Util";
import './Landingpage.css';
import $ from 'jquery';
import store from 'store';
import { Link } from 'react-router-dom';

class Course extends Home {
	constructor(props) {
		super(props);
		let params = QueryParam();
		this.state = { 
			kursus: [],
			max_title_length: 45,
			params: params
		};
	}

	componentDidMount() {
		this.handleLoadData()
	}

	componentWillReceiveProps(props) {		
		let params = QueryParam();		
		this.setState({ params: params });
	}

	componentDidUpdate(prevProps){
		if(this.props.location.search !== prevProps.location.search){
			this.handleLoadData(QueryParam());
		}
	}

	handleLoadData = params => {
		if (!params) {
			params = this.state.params;
		}

		$.get(API_COURSE_BASE_URL, params)
		.then((data) => {
			//   let courseData = { kursus: datadump.data }; //dump data
		  let courseData = { kursus: data.payload };
		  store.set("course_data", courseData);

		  this.setState(courseData);
		});
		
	};

	renderTitle = (title) => {
		return title.length < this.state.max_title_length ? title : title.substring(0, this.state.max_title_length) + "..."
	}

	getKurses = () => {
		var course = (
		  this.state.kursus.map(item => (
			  <Col
				l={3}
				m={3}
				s={12}
			  >
				<Card
				  closeIcon={<Icon>close</Icon>}
				  header={<CardTitle image={item.thumbnail}></CardTitle>}
				  revealIcon={<Icon>more_vert</Icon>}
				>
				  <Link to={`/course/${item.slug}`}>
					  	<div className="content-desktop">{ this.renderTitle(item.title) }</div>
					  	<div className="content-mobile">{ item.title }</div> 
				  		<div style={{bottom: "0px"}}>Rp. { item.final_price }</div>
				  </Link>
				</Card>
			  </Col>          
		  ))
		)
		return course;
	}  

	render() {
		const sectionname = {
			display:'flex',
			justifyContent:'center',
			alignItems:'center',
			color: "#df2e2e",
			margin: "20px",
			padding: "20px",
			fontSize: "1.5em",
			fontWeight: "bold",
	  };

		let announcement = this.state.announcement;
		let isLogin = CheckAuth() != "";
		let params = this.state.params;
		let addedTitle = params.t? ( params.t == 'spl'? 'Mandiri':'Webinar') : "";

		return (
			<div style={{position:'relative', overflow:'hidden'}}>
				<div style={{
					position:'absolute',
					top:'30%'
				}}>
					<img 
						style={{
							position:'absolute', 
							width:'150px',
							left:'25px',
							zIndex:3,
						}}
						src="/img/ornament/Banner-06.png" 
					/>
					<img 
						style={{
							position:'absolute', 
							width:'200px',
							top:'-3px',
							left:'-35px',
							zIndex:2,
						}}
						src="/img/ornament/strip-right.jpg" 
					/>
				</div>
				<div style={{
					position:'absolute',
					top:'55%',
					right:'15%'
				}}>
					<img 
						style={{
							position:'absolute', 
							width:'150px',
							zIndex:3,
						}}
						src="/img/ornament/Banner-09.png" 
					/>
					<img 
						style={{
							position:'absolute', 
							width:'200px',
							top:'4px',
							right:'-220px',
							zIndex:2,
						}}
						src="/img/ornament/strip-left.jpg" 
					/>
				</div>
				<div className="bg-white pad-xl fadeIn wow">		
					<div style={sectionname}>
						<img 
							style={{width:'30px'}}
							src="/img/ornament/Banner-12.png"
						/>	
						<h4 style={{marginBottom:0}}>Daftar Kelas {addedTitle}</h4>
						<img 
							style={{width:'30px'}}
							src="/img/ornament/Banner-13.png"
						/>      
					</div>
					<div className="container">
						{params.query && 
							<h5 className="mb-m">
								<span className="font-grey">
									Dengan Kata Kunci Pencarian :{" "}
								</span>
								{params.query}
							</h5> 
						}
						<Row>
							{this.getKurses()}
						</Row>
					</div>
				</div>
                                
			</div>
		);
	}
}


export default Course;



// WEBPACK FOOTER //
// ./src/components/Public/Home/Course.js